import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { useDeleteFavoredContactMutation } from '../../services/pixFavoredContactApi';
export function useDeleteFavoredContact() {
    const { t } = useTranslation();
    const [trigger] = useDeleteFavoredContactMutation();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorDeleteFavoredContactMessage, setErrorDeleteFavoredContactMessage] = useState();
    async function deleteFavoredContact(contactId) {
        setLoading(true);
        setErrorDeleteFavoredContactMessage(undefined);
        try {
            const { error } = await trigger({ contactId });
            if (error) {
                setErrorDeleteFavoredContactMessage(t('select-contact-delete-modal-error-message'));
                return;
            }
            setSuccess(true);
            return true;
        }
        catch {
            setErrorDeleteFavoredContactMessage(t('select-contact-delete-modal-error-message'));
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        success,
        errorDeleteFavoredContactMessage,
        setErrorDeleteFavoredContactMessage,
        setLoading,
        deleteFavoredContact,
    };
}
